import { forEach } from 'lodash';

export default function calculateReservationSpace(
  tableData,
  divHeight,
  timeArray
) {
  const reservationSpace = {};
  forEach(tableData, (reservation) => {
    const placeName = reservation.place;
    const placeId = reservation.placeId;
    reservationSpace[placeId] = { placeNr: placeName };
    forEach(reservation.slots, (slot) => {
      const hours = parseInt(slot.timeTo, 10) - parseInt(slot.timeFrom, 10);
      let counter = 1;
      const { reservationId } = slot;
      forEach(timeArray, (timeSlot, timeId) => {
        let obj = {};
        const { from, to } = timeSlot;
        if (typeof reservationSpace[placeId][timeId] !== 'object') {
          reservationSpace[placeId][timeId] = {};
        }
        if (
          parseInt(slot.timeFrom, 10) <= parseInt(from, 10) &&
          parseInt(slot.timeTo, 10) >= parseInt(to, 10)
        ) {
          const height = hours * divHeight > 780 ? 780 : hours * divHeight;
          const top = timeId * divHeight;
          const permanentReservation = reservationId === null;
          obj = {
            from,
            to,
            status: 'filled',
            span: hours,
            start: counter,
            name: slot.fullName,
            top,
            height,
            place: placeName,
            permanent: permanentReservation
          };
          counter += 1;
          reservationSpace[placeId][timeId] = obj;
        }
      });
    });
  });
  return reservationSpace;
}

export const findFirstReservationTime = (tableData) => {
  let startTime = 9;
  forEach(tableData, (reservation) => {
    forEach(reservation.slots, (slot) => {
      if (
        parseInt(slot.timeFrom, 10) < parseInt(startTime, 10) &&
        parseInt(slot.timeFrom, 10) > 0
      ) {
        startTime = slot.timeFrom;
      }
    });
  });
  return startTime;
};
